import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';

/**
 * Invalidate a React Query key whenever the gateway pushes a realtime event.
 *
 * The socket layer (`lib/socket.ts`) re-broadcasts server events as window
 * CustomEvents (`notification:new`, etc.). A page subscribes here to refetch
 * the instant something relevant happens — replacing 30s polling with push.
 */
export function useRealtimeInvalidate(
  queryKey: unknown[],
  events: string[] = ['notification:new'],
): void {
  const qc = useQueryClient();
  const key = JSON.stringify(queryKey);
  useEffect(() => {
    const handler = () => void qc.invalidateQueries({ queryKey });
    events.forEach((e) => window.addEventListener(e, handler));
    return () => events.forEach((e) => window.removeEventListener(e, handler));
    // queryKey serialized to `key`; events list is a stable literal at call sites.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);
}
